import { createContext } from 'react';

import { MissingToolMappingItems } from '@totem/components/salesOrders/missingToolMappings/types';

interface Context {
  loading: boolean;
  reportData: MissingToolMappingItems;
  totalRecords: number;
  searchText: string;
  setSearchText: (val: string) => void;
  refetch: () => void;
}

const MissingToolMappingsContext = createContext<Context>({
  loading: false,
  reportData: [],
  totalRecords: 0,
  searchText: '',
  setSearchText: () => {},
  refetch: () => {},
});

export default MissingToolMappingsContext;
